






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class DayOfWeek extends Vue {
  //@ts-ignore
  @Prop() conditions: any;
  name: string = 'dayOfWeek';

  predicate: string = 'EQUALS';
  selected: any[] = new Array(7);
  days: any = [
    this.t('Sunday'),
    this.t('Monday'),
    this.t('Tuesday'),
    this.t('Wednesday'),
    this.t('Thursday'),
    this.t('Friday'),
    this.t('Saturday'),
  ];

  mounted() {
    if (!this.conditions.dayOfWeek) {
      this.conditions.dayOfWeek = {};
    } else {
      this.selected = this.days.map(
        (e: any) => this.conditions.dayOfWeek.values.indexOf(e) !== -1 && e
      );

      this.predicate = this.conditions.dayOfWeek.predicate || this.predicate;
    }
  }

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.dayOfWeek) {
      this.$set(this.conditions, 'dayOfWeek', {
        predicate:  'EQUALS',
        values: []
      });
    }
  }

  @Watch('selected', {
    deep: true
  })
  onSelectedChanged(value: any, oldValue: any) {
    this.$set(this.conditions.dayOfWeek, 'values', this.selected.filter((e: any) => e));
  }

  @Watch('predicate')
  onPredicateChanged(value: any, oldValue: any) {
    this.$set(this.conditions.dayOfWeek, 'predicate', value);
  }
}
